import LocationItems from '../locationItems';

export default class ProductLocation {
	product: LocationItems;
	locations: LocationContainItem[] = new Array<LocationContainItem>();
}

class LocationContainItem {
	orderNo: number;
	productLocationId: number;
	locationId: number;
	productId: number;
	locationCode: string;
	locationType: string;
	locationTypeName: string;
	qty: number;
}
